import { useContext } from "react";
import { QCContext, UserContext } from "../../context/UserContext";
import { getPanelList, getPOLinkedBinList, getPOList } from "../../services/qcService";
import { fetchProjectData } from "../../services/station";
import styles from './BoardView.module.css';

import { useQueries, useQuery } from "@tanstack/react-query";
import Button from "../../components/Button";
import Tag from "../../components/Tag";

function BoardView() {
  const {workOrder, currentFactory, toastList, setToastList, selectedLocation} = useContext(UserContext);
  const {setSelectedPO, setWoPanelList} = useContext(QCContext);
  const {data: poList, isLoading} = useQuery(['qcPOlist', workOrder], async () => {
    let filteredData = {};
    const projectList = await fetchProjectData(
      {
        _factory_code: currentFactory.item_code,
        stockpile_id: workOrder.id,
        hideinactive : false
      }
    )
    if (projectList.status === 200) {
      if (projectList.message.projects.length === 0) {
        showToast({type: 'error', message: 'Projects not found.', autoClose: false});
        return filteredData
      }

      const poList = await getPOList({
        factory_code: currentFactory.item_code,
        projects_list: projectList.message.projects
      });
      poList.map(po => {
        filteredData[po.customer_order_id] = '';
        return po;
      })
      // if (poList.status !== 200) {
      //   showToast({type: 'error', message: poList.message || 'Internal Server Error', autoClose: false});
      // } else {
        const linkedBin = await getPOLinkedBinList({
          factory_code: currentFactory.item_code,
          po_codes: poList.map((project) => project.customer_order_id)
        });

        if (linkedBin.status === 200) {
          // check other conditions
          linkedBin.message.map((binObj) => {
            if (filteredData[binObj.po_code] !== undefined) {
              filteredData[binObj.po_code] = filteredData[binObj.po_code] ? (filteredData[binObj.po_code] + ', ' + binObj.bin) : binObj.bin
            } 
            return binObj;
          })
        } else {
          showToast({type: 'error', message: linkedBin.message || 'Internal Server Error', autoClose: false});
        }
      // }
      return filteredData
    } else {
      showToast({type: 'error', message: projectList.message || 'Internal Server Error', autoClose: false});
      return filteredData
    }
  }, {
    refetchOnWindowFocus: false,
    retry: false
  })

  const poListTemp = poList ? Object.keys(poList) : [];

  const panelListData = useQueries({
    queries: poListTemp.map((po) => {
      return {
        queryKey: ['panelList', po],
        queryFn: () => fetchPanelDetails(po),
        refetchOnWindowFocus: false,
        retry: false
      }
    })
  })

  const fetchPanelDetails = async (po_code) => {
    let payload = {
      factory_code: currentFactory.item_code,
      location: selectedLocation.location,
      po_code: po_code,
      sorted_panels: false
    }
    const response = await getPanelList(payload);
    let scannedParts = response.message.parts.filter(part => (part.status === 'pending' || part.status === 'approved')).length;
    let totalParts = response.message.total_parts_for_po;
    setWoPanelList(prev => ({...prev, [response.message.parts[0].part.split('_')[0]]: po_code.split('-')[2]}))
    return {
      sortedQty: scannedParts + ' / ' + totalParts,
      status: scannedParts === totalParts ? 'completed' : 'pending'
    };
  }

  const showToast = ({type, message, action, autoClose = true}) => {
    // show toast message
    let toast = {
      type: type,
      text: message,
      onClick: action ? () => console.log('button clicked') : undefined,
      autoClose: autoClose
    }
    setToastList([...toastList, toast]);
  }
  if (isLoading) return <div style={{textAlign: 'center'}}>Please wait while we are loading board details. Nevertheless, Barcode scanning will still work</div>

  return (
    <>
      <div className={styles.boardHeader}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <span style={{fontWeight: 700}}>PO List</span> 
          {/* <span className="ft-12" style={{fontWeight: 400, marginLeft: '4px'}}>({boardData.filteredData.length})</span> */}
        </div>
      </div>
      <div className="table-responsive">
        <table className="table block">
          <thead>
            <tr>
              <th className="ft-12">PO code</th>
              <th className="ft-12">BIN LOCATION</th>
              <th className="ft-12">SORTED QTY</th>
              <th className="ft-12">STATUS</th>
              {/* <th className="ft-12">PROD COMPLETED</th>
              <th className="ft-12">QC REQUEST NUMBER</th> */}
            </tr>
          </thead>
          <tbody>
            {poList && Object.keys(poList).map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item}</td>
                  <td>{poList[item] || '-'}</td>
                  <td>{panelListData && panelListData[index]?.data?.sortedQty}</td>
                  <td>
                    {panelListData && panelListData[index]?.data?.status === 'completed' ? 
                      (<Tag type='primary' fillStyle='outline' icon='check_circle'>Completed</Tag>) :
                      (<Tag type='tertiary' fillStyle='filled'>Pending</Tag>)
                    }
                  </td>
                  <td><Button type={'linkSecondary'} onClick={() => setSelectedPO(item)}>View Details</Button></td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default BoardView;
